
import { Image, Text } from "@react-three/drei"
import { mainStore } from "../store"
import { __ } from "../utils"



export default function Team({ position, scale, year = false, offsetNumber = 0, children }) {

    /**
     * Setup
     */
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)


    return <group scale={scale} position={position}>
        {year && <> <Text
            maxWidth={2}
            anchorX={0}
            anchorY={0}
            lineHeight={0.8}
            fontSize={0.2}
            position={[1.42, -1.54, 0]}
            font={fonts.ms.title}
            color={colors.title}
            fontWeight={''}

        >
            {year}
        </Text>
            <Image
                position={[1.62, -1.31, -0.1]}
                url={import.meta.env.BASE_URL + "static/icons/collaborators.png"}
                transparent
                zoom={0.5}
                scale={0.65}

            />
        </>
        }

        {
            !year &&  <Image
            position={[1.6, -1.5, -0.1]}
            url={import.meta.env.BASE_URL + "static/icons/collaborators.png"}
            transparent
            zoom={0.5}
            scale={0.8}

        />
        }

        <Text
            maxWidth={1}
            lineHeight={0.8}
            fontSize={0.29}
            position={[1.05 + offsetNumber, -1.75, 0]}
            font={fonts.ms.title}
            color={colors.title}
            fontWeight={'bold'}
        >
            {children}
            <meshBasicMaterial depthTest={false} />
        </Text>
        <Text
            maxWidth={1}
            lineHeight={0.8}
            fontSize={0.1}
            position={[1.6, -1.8, 0]}
            font={fonts.ms.text}
            color={colors.title}
            fontWeight={''}

        >
            {__('collaborateurs', 'collaborators')}
            <meshBasicMaterial depthTest={false} />
        </Text>

    </group>
}